import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { UrlServidor } from "../util/url-servidor";
import { PageRequest } from "../api/dto/paginacao/page-request";
import { Observable } from "rxjs";
import { PageResponse } from "../api/dto/paginacao/page-response";
import { ItemServicoAgendamento } from "../api/dto/item-servico-agendamento";
import { HttpParamsUtil } from "../util/http-params-util";

@Injectable({
    providedIn: 'root',
})
export class ItemServicoAgendamentoService {

    constructor(private http: HttpClient) { }

    private url: string = UrlServidor.URL_BASE + 'itens-servicos-agendamentos';

    listarAgendaveis(
        profissionalId: number,
        busca?: string,
        pageRequest?: PageRequest
    ): Observable<PageResponse<ItemServicoAgendamento>> {

        const params = HttpParamsUtil.buildHttpParams({
            busca,
            page: pageRequest?.page,
            size: pageRequest?.size,
            sort: pageRequest?.sort
        });

        return this.http.get<PageResponse<ItemServicoAgendamento>>(
            `${this.url}/profissionais/${profissionalId}`,
            { params }
        );
    }
}